
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/verkauf/[id]",
      function () {
        return require("private-next-pages/verkauf/[id].tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/verkauf/[id]"])
      });
    }
  